import "./Botonescaja.css";

//Form size buttons
const Botonescaja = ({ children }) => {
  return <div className="botonescaja">{children}</div>;
};

export default Botonescaja;
